import {listActionTypes} from "../../settings/types";

export const clearState = () => ({
    type : listActionTypes.clearState,
});

export const setItems = data => ({
    type: listActionTypes.listDomainObjects,
    payload: data
});

export const setFilter = data => ({
    type: listActionTypes.filter,
    payload: data
});

export const setTableParams = ( pageSize= 10, pageIndex= 0, totalSize= 0, currentPage =1) => ({
    type : listActionTypes.tableParams,
    payload: { pageSize, pageIndex, totalSize, currentPage }
});

export const removeItem = data => ({
    type : listActionTypes.removeItem,
    payload: data
});

export const addItem = data => ({
    type : listActionTypes.addItem,
    payload: data
});

export const changeListItem = data => ({
    type : listActionTypes.changeItem,
    payload: data
});

export const reload = () => ({
    type : listActionTypes.reload,
});